import React from 'react';

import { Button } from 'components/ui/button';

interface Props {
  buttonLabel: string;
  dateLabel: string;
  disabled: boolean;
  saving: boolean;
  onSubmit: () => void;
}

export default function PanelFooter({
  buttonLabel,
  dateLabel,
  disabled,
  saving,
  onSubmit,
}: Props) {
  return (
    <div className="d-flex justify-content-end align-items-center gap-3">
      <span className="text-muted small">{dateLabel}</span>
      <Button disabled={disabled || saving} onClick={onSubmit}>
        {buttonLabel}
      </Button>
    </div>
  );
}
